import React from "react";

interface Calendar1Props {
  width?: number;
  height?: number;
  strokeColor?: string;
  fillColor?: string;
}
const Calendar1 = ({
  width = 20,
  height = 20,
  strokeColor,
  fillColor,
}: Calendar1Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill={fillColor || "none"}
    >
      <path
        d="M8.25 11H9V14"
        stroke={strokeColor || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2V5"
        stroke={strokeColor || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 8H15.75"
        stroke={strokeColor || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2V5"
        stroke={strokeColor || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 3.5H3.75C2.92157 3.5 2.25 4.17157 2.25 5V15.5C2.25 16.3284 2.92157 17 3.75 17H14.25C15.0784 17 15.75 16.3284 15.75 15.5V5C15.75 4.17157 15.0784 3.5 14.25 3.5Z"
        stroke={strokeColor || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Calendar1;
